import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import "rxjs/add/operator/map";

import { AngularFireAuth, AngularFireAuthProvider } from 'angularfire2/auth';
import { app } from "firebase"
import * as firebase from "firebase";

@Injectable()
export class AuthenticationService {

    constructor(
        private http: Http,
        public afAuth: AngularFireAuth
    ) {
    }

    getToken() {
        return new Promise((resolve) => {
            this.afAuth.auth.onAuthStateChanged(auth => {
                if (auth) {
                    auth.getIdToken(true)
                        .then((idToken) => {
                            localStorage.setItem('token', idToken);
                            console.info('!! GET TOKEN PROMISE !!' + new Date());
                            resolve(idToken);
                        })
                }
            })
        });
    }

    fbLogin() {
        const provider = new firebase.auth.FacebookAuthProvider();
        return this.afAuth.auth.signInWithPopup(provider);
    }

    login(email: string, password: string) {
        return this.afAuth.auth.signInWithEmailAndPassword(email, password);

        // return this.http.post('/api/authenticate', JSON.stringify({ email: email, password: password }))
        //     .map((response: Response) => {
        //         // login successful if there's a jwt token in the response
        //         let user = response.json();
        //         if (user && user.token) {
        //             console.debug(JSON.stringify(user))
        //             // store user details and jwt token in local storage to keep user logged in between page refreshes
        //
        //         }
        //     });
    }

    logout() {
        // remove user from local storage to log user out
        return this.afAuth.auth.signOut();
    }
}


// WEBPACK FOOTER //
// ./src/app/auth/_services/authentication.service.ts